import ProcessFlowCallToAction from "~/models/processFlows/callToActions/processFlowCallToAction"
import {CallToActionType} from "~/enums/processFlows/callToActionType"
import {
  IProcessFlowMappedVariable,
  IProcessFlowCallToAction,
} from "~/interfaces/processFlowInterfaces"
import ProcessFlowStepCallToActionDefinition from '~/models/processFlows/processFlowStepCallToActionDefinition';

interface IProcessFlowCallToActionBaseFormSubmission extends IProcessFlowCallToAction {
  variable_reference: IProcessFlowMappedVariable
  variableReference: IProcessFlowMappedVariable
}

export default abstract class BaseFormSubmissionCallToAction extends ProcessFlowCallToAction implements IProcessFlowCallToActionBaseFormSubmission {
  abstract action_type: CallToActionType;
  variable_reference: IProcessFlowMappedVariable;

  constructor(protected _rootName: string, options: any = {}) {
    super(_rootName, options)
    this.defineProperty("button_label", ProcessFlowStepCallToActionDefinition.typeSelectOption(options.actionType).label)
  }

  get hasVariableReference(): boolean {
    return this.variableReference.pathExists
  }

  get variableReference(): IProcessFlowMappedVariable {
    return this.variable_reference || this.createVariableReference()
  }

  get isValid(): boolean {
    return (!this.buttonLabelRequired || Boolean(this.button_label)) &&
      this.hasVariableReference
  }
}